import { render, staticRenderFns } from "./NotificationPharmacySitesApprovalRequest.vue?vue&type=template&id=1897a97a"
import script from "./NotificationPharmacySitesApprovalRequest.vue?vue&type=script&lang=js"
export * from "./NotificationPharmacySitesApprovalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports